export type MemberSummary = {
  personId: string;
  displayName: string;
  organizationId: string;
  organizationName: string;
  statusCode: string;
  statusLabel: string;
  joinedYear: number | null;
  approvedOn: string | null;
  sectorCode: string | null;
  sectorLabel: string | null;
};

export type MemberFact = {
  id: string;
  kind: string;
  kindLabel: string;
  title: string;
  subtitle: string | null;
  primaryLabel: string | null;
  secondaryLabel: string | null;
  note: string | null;
  startOn: string | null;
  endOn: string | null;
  sourceRef: string;
};

export type MemberDetail = {
  personId: string;
  displayName: string;
  // WO-113（2026-10-19）：组织登记，本人只读，会员端不显示。
  birthDate: string | null;
  age: number | null;
  nativePlace: string | null;
  householdRegistration: string | null;
  workStartOn: string | null;
  /** 只有「有没有」与掩码；全号走重认证后的单独读取。 */
  idDocument: { recorded: boolean; masked: string | null };
  ethnicityCode: string | null;
  ethnicityLabel: string | null;
  politicalStatusCode: string | null;
  politicalStatusLabel: string | null;
  organizationId: string;
  organizationName: string;
  version: number;
  membership: {
    statusCode: string;
    statusLabel: string;
    joinedYear: number | null;
    approvedOn: string | null;
    sectorCode: string | null;
    sectorLabel: string | null;
    isEconomicPerson: boolean | null;
    localNumber: string | null;
    centralNumber: string | null;
    // WO-113：上级报表口径。中上层只是口径标记，不参与评价与排序。
    representativeTier: boolean | null;
    enterpriseScaleCode: string | null;
    enterpriseScaleLabel: string | null;
    isCentralEnterprise: boolean | null;
    postingDepartmentTypeCode: string | null;
    postingDepartmentTypeLabel: string | null;
    postingRankCode: string | null;
    postingRankLabel: string | null;
    sourceRef: string;
  };
  declaredAttributes: Record<string, string>;
  appointments: import("./organization-model").Appointment[];
  facts: MemberFact[];
  derived: {
    highestEducationLabel: string | null;
    workStartOn: string | null;
    workYears: number | null;
  };
};

export type DictionaryItem = { itemCode: string; displayName: string };
export type Dictionary = { dictCode: string; displayName: string; items: DictionaryItem[] };

export const ATTRIBUTE_LABELS: Record<string, string> = {
  MOBILE: "联系电话",
  WORK_UNIT: "工作单位",
  POSITION: "职务",
  INTERNAL_DUTY: "会内职务",
  MAILING_ADDRESS: "通讯地址"
};

export const FACT_KINDS = [
  {
    kind: "EDUCATION",
    label: "教育经历",
    primary: "EDUCATION_LEVEL",
    secondary: "DEGREE",
    titleLabel: "毕业院校",
    subtitleLabel: "所学专业"
  },
  {
    kind: "EMPLOYMENT",
    label: "任职经历",
    primary: "EMPLOYER_TYPE",
    secondary: "INDUSTRY",
    titleLabel: "工作单位",
    subtitleLabel: "职务"
  },
  {
    kind: "CREDENTIAL",
    label: "职业资格与职称",
    primary: "CREDENTIAL_TYPE",
    secondary: "PROFESSIONAL_TITLE_LEVEL",
    titleLabel: "名称",
    subtitleLabel: "等级"
  },
  {
    kind: "POLITICAL_ARRANGEMENT",
    label: "政治安排",
    primary: "POLITICAL_ARRANGEMENT_KIND",
    secondary: null,
    titleLabel: "所在机构",
    subtitleLabel: "职务"
  },
  {
    kind: "SOCIAL_ROLE",
    label: "社会职务",
    primary: null,
    secondary: null,
    titleLabel: "所在组织",
    subtitleLabel: "职务（必填）"
  },
  {
    kind: "RECOGNITION",
    label: "表彰与荣誉",
    primary: null,
    secondary: null,
    titleLabel: "表彰名称",
    subtitleLabel: null
  }
] as const;

/** 三态布尔的显示：未登记 / 是 / 否——「不知道」与「不是」是两回事。 */
export function triStateLabel(value: boolean | null): string {
  return value === null ? "未登记" : value ? "是" : "否";
}
